import React from "react";
import PropTypes from "prop-types";

import useCredentialsForm from "./hooks/useCredentialsForm";
import { Button, Form } from "..";

export function CreateForm({ email, disabled, onSubmit }) {
  const formProps = useCredentialsForm(email);

  return (
    <Form {...formProps} onSubmit={onSubmit}>
      <div style={{ marginTop: "22px" }}>
        <Form.Input
          name="email"
          label="Email"
          disabled={!!email}
          fluid
          defaultValue={email}
          placeholder="Enter your email"
          style={email ? { opacity: "0.45" } : {}}
        />
      </div>

      <div style={{ marginBottom: "22px" }}>
        <Form.Password name="password" />
      </div>

      <Form.Password
        name="passwordConfirmation"
        label="Confirm password"
        placeholder="Repeat password"
        showDefaultError={false}
      />
      <Button disabled={disabled} primary fluid style={{ margin: "22px 0px" }}>
        Sign Up
      </Button>
    </Form>
  );
}

CreateForm.propTypes = {
  email: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

CreateForm.defaultProps = { email: "", disabled: false };

export default CreateForm;
